import { useEffect }            from 'react';
import { store }                from 'index';
import { groupUrl }             from 'utils/constants'
import { whiteList }            from 'utils/constants';
import { SET_GET_CONTENT_ONCE } from 'actions/contentActions';
import { 
  GET_CONTENT_SAGA,
  GET_TEACHER_CONTENT_SAGA
}                               from 'actions';

const useGetContent = () => {

      const state              = store.getState();
      const { getContentOnce } = state.content;
      const { userInfo }       = state.data;
      const userIsZvi          = whiteList.includes(userInfo.userEmail);

      useEffect(() => {

        if (!groupUrl && userInfo.userEmail.length > 0 && !getContentOnce ) {

            const userIsGuest = userInfo.userEmail === 'guest@yisumatica.org.il';

            const payload = {
              userIsGuest: userIsGuest,
              userIsZvi:   userIsZvi,
              plus:        userInfo.plus,
              gradeAccess: userInfo.gradeAccess
            }
      
            store.dispatch(SET_GET_CONTENT_ONCE());
            store.dispatch(GET_CONTENT_SAGA(payload));

            if (!userIsGuest) {
               store.dispatch(GET_TEACHER_CONTENT_SAGA({ userIsZvi: userIsZvi }));
            }
            
        }

      },[userInfo, getContentOnce, userIsZvi])
    
}
export default useGetContent;

